<script setup lang="ts">
import type { PortableTextMarkComponentProps } from "@portabletext/vue";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<
  PortableTextMarkComponentProps<{
    _key: string;
    _type: string;
    anchorId?: string;
  }>
>();

const scrollToTarget = (e: Event) => {
  e.preventDefault();
  
  if (!props.value?.anchorId) return;

  const clickedLink = e.currentTarget as HTMLElement;
  const targetElement = document.getElementById(props.value.anchorId) as HTMLElement;
  
  if (!targetElement || targetElement === clickedLink || clickedLink.contains(targetElement)) {
    return;
  }
  
  // Get header height from CSS variable, fallback to 100px
  const headerHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '100px';
  const headerHeight = parseInt(headerHeightValue.replace('px', '')) || 100;
  
  // Calculate scroll position: element position minus header height
  const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
  const scrollPosition = elementTop - headerHeight;
  
  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  });
};
</script>

<template>
  <a
    v-if="props.value?.anchorId"
    href="#"
    @click="scrollToTarget"
    class="c-internal-text-anchor"
    :title="`Link to anchor: ${props.value.anchorId}`"
  >
    <slot />
  </a>
  <span v-else>
    <slot />
  </span>
</template>

<style scoped>
.c-internal-text-anchor {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  transition: opacity 0.2s;
}

.c-internal-text-anchor:hover {
  opacity: 0.7;
}
</style>

